import { render, staticRenderFns } from "./MouvementResidence.vue?vue&type=template&id=16c3fb4e&"
import script from "./MouvementResidence.vue?vue&type=script&lang=js&"
export * from "./MouvementResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports